<template>
  <el-tooltip
    :disabled="!item.onlyRegistered"
    class="item"
    effect="dark"
    placement="top-start"
  >
    <template slot="content">
      <span class="" v-if="item.onlySubscribed">
        For {{ item.memberships[0].name }} Only
      </span>
      <span class="" v-if="item.onlyRegistered && !item.onlySubscribed">
        For Registered Users Only
      </span>
    </template>
    <div
      class="blog-tooltip-ui md:mt-5 lg:mt-5 mt-2 text-black footertitle font-bold cursor-pointer fsize24-14px ellipsis-2 shadow-xl rounded-b-lg bg-white"
    >
      <!-- @click="handleReadMore" -->
      <div class="" @click="link">
        <a class="cursort-pointer">
          <!-- <div
          class="relative"
          v-if="
            Object.keys(user).length !== 0 &&
            Object.hasOwn(user, 'currentMembership') &&
            user.currentMembership.length !== 0 &&
            user.currentMembership != null &&
            Object.hasOwn(item, 'memberships') &&
            item.memberships != null &&
            Object.keys(item.memberships).length !== 0
          "
        >
          <span class="absolute top-3 left-1 z-index-999">
            <img
              class="rounded-full w-6 h-6"
              :src="$imageURL + '/' + item.memberships[0].image"
              :style="{}"
            />
          </span>
        </div> -->
          <div class="relative">
            <span
              class="absolute top-3 left-3 z-index-999 bg-ede3fa py-1 px-3 rounded-full fsize15 text-primary"
              v-if="item.onlySubscribed"
            >
              For Subscribers Only
            </span>
            <span
              class="absolute top-3 left-3 z-index-999 flex gap-1 bg-ede3fa py-1 px-3 rounded-full fsize15 text-primary"
              v-if="item.onlyRegistered && !item.onlySubscribed"
              ><feather-icon icon="UnlockIcon" svgClasses="w-4" />
              Access Caregiver Saathi
            </span>
          </div>
          <!-- <div
          class="relative"
          v-if="
            Object.keys(user).length == 0 &&
            Object.hasOwn(item, 'memberships') &&
            item.memberships != null &&
            Object.keys(item.memberships).length !== 0
          "
        >
          <span class="absolute top-3 left-1 z-index-999">
            <img
              class="rounded-full w-6 h-6"
              :src="$imageURL + '/' + item.memberships[0].image"
              :style="{}"
            />
            {{ item.memberships[0].name }}
          </span>
        </div> -->

          <img
            v-if="selectedFilter != null"
            :src="
              item.bannerImage
                ? `${$imageURL}/${item.bannerImage}`
                : defaultImage
            "
            alt="Blog image"
            class="rounded-t-lg h-52 w-full object-contain cursor-pointer"
          />
          <img
            v-else
            :src="hasError ? defaultImage : image"
            alt="Blog image"
            class="rounded-t-lg h-52 w-full object-contain cursor-pointer"
          />
          <div class="p-4 bg-white">
            <p
              class="text-black font-bold cursor-pointer fsize18px sm-fsize14 ellipsis-3 lh-28"
            >
              {{ item.title }}
            </p>
          </div>
        </a>
        <!-- <div class="md:mt-5 lg:mt-5 mt-2 flex">
        <p class="text-xs clr777 font-normal">1 Hour ago</p>
                <p class="text-xs clr777 font-normal ml-6">200 views</p>
      </div> -->
      </div>
      <!-- <span class="blog-tooltiptext-ui" v-if="item.onlySubscribed">
      For {{ item.memberships[0].name }} Only
    </span>
    <span
      class="blog-tooltiptext-ui"
      v-if="item.onlyRegistered && !item.onlySubscribed"
    >
      For Registered Users Only
    </span> -->
    </div>
  </el-tooltip>
</template>

<script>
// export default {
//   data() {
//     return {
//       pc: [
//         {
//           img: require("../../../../assets/images/podcast1.png"),
//           title: "Caregiver Diaries",
//           link: "https://sochcast.com/web/sochcast/main?show=440&v=episodes?show=440",
//         },
//         {
//           img: require("../../../../assets/images/podcast2.png"),
//           title: "Conversations with Gentle Warriors",
//           link: "https://sochcast.com/web/sochcast/main?show=439&v=episodes?show=439",
//         },
//       ],
//     };
//   },
// };
//
</script>
<script>
import pageMixin from "@/views/social/admin/pages/blog/mixins/pageMixin";
import { mapState } from "vuex";
import Swal from "sweetalert2";

export default {
  // mixins: [pageMixin],
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    category: {
      type: String,
      default: "blog",
    },
    selectedFilter: {
      type: String,
    },
  },
  data() {
    return {
      redirectLink: "",
      hasError: false,
      defaultImage:
        this.$imageURL + "/caregiversaathi/default/dummy%20image.jpg",
    };
  },
  computed: {
    image() {
      return this.item.image
        ? `${this.$imageURL}/${this.item.image}`
        : this.defaultImage;
    },
    // link() {
    // if (this.item.link.includes("http")) {
    //   return this.item.link;
    // } else {
    //   return "https://" + this.item.link;
    // }
    // },
    ...mapState("cms", {
      pageCategories: "pageCategories",
      filtertags: "filtertags",
      filters: "filters",
      pages: "pages",
      categorywisepages: "categorywisepages",
    }),

    ...mapState("auth", { user: "user" }),
    ...mapState("auth", { getUserByUserId: "getUserByUserId" }),
  },
  methods: {
    async link() {
      // console.log(this.categorywisepages.data);
      let clickedBlogId = "";
      if (Object.keys(this.user).length !== 0) {
        this.categorywisepages.data.forEach((element) => {
          if (element._id === this.item._id) {
            if (
              element.memberships != null &&
              element.memberships.length !== 0
            ) {
              clickedBlogId = element.memberships[0]._id;
            }
          }
        });
      }
      if (this.item.onlyRegistered) {
        if (Object.keys(this.user).length === 0) {
          this.$router.push({ name: "signin" });
          Swal.fire({
            title: "Login",
            text: "To access the content, kindly proceed with registration/login",
            icon: "warning",
            confirmButtonColor: "#830c81",
            showConfirmButton: true,
          });
          return;
          // .then((result) => {
          //   if (result.isConfirmed) {
          //     this.$router.push({ name: "signin" });
          //   }
          // });
        } else if (this.item.onlySubscribed) {
          if (
            this.user.membership != null &&
            this.user.membership.includes(clickedBlogId)
          ) {
            const routeData = this.$router.resolve({
              name: "blogspage",
              params: {
                id: this.item._id,
                slug: this.item._id,
                category: this.category,
              },
            });

            // if (this.item.link.includes("http")) {
            //   this.redirectLink = this.item.link;
            // } else {
            //   this.redirectLink = "https://" + this.item.link;
            // }
            // window.open(this.redirectLink, "_blank");
            await this.selectItem();
          } else {
            Swal.fire({
              title: "Upgrade Plan",
              text: "Upgrade now for unrestricted access!",
              icon: "info",
              confirmButtonColor: "#830c81",
              confirmButtonText: "Show Plans",
              showConfirmButton: true,
              showCancelButton: true,
            }).then((e) => {
              if (e.isConfirmed) {
                this.$router.push({
                  path: "/product-services",
                  query: { buymembership: true },
                });
              }
            });
          }
        } else {
          // if (this.item.link.includes("http")) {
          //   this.redirectLink = this.item.link;
          // } else {
          //   this.redirectLink = "https://" + this.item.link;
          // }
          // window.open(this.redirectLink, "_blank");
          await this.selectItem();
        }
      } else {
        // alert();

        // if (this.item.link.includes("http")) {
        //   this.redirectLink = this.item.link;
        // } else {
        //   this.redirectLink = "https://" + this.item.link;
        // }
        // window.open(this.redirectLink, "_blank");
        await this.selectItem();
        // await this.$store.commit("cms/SET_SELECTED_LIST", this.item);
        // const routeData = this.$router.resolve({
        //   name: "blogspage",
        //   params: {
        //     id: this.item._id,
        //     slug: this.item._id,
        //     category: this.category,
        //   },
        // });
        // window.open(routeData.href, "_blank");
      }
    },
    selectItem() {
      this.$emit("item-selected", this.item);
    },
  },
  async mounted() {
    // if (Object.keys(this.user).length !== 0) {
    //   let getUserPayload = {
    //     userId: this.user._id,
    //   };
    //   const getUser = await this.$store.dispatch(
    //     "auth/getUserByUserId",
    //     getUserPayload
    //   );
    // }
  },
};
</script>
